export default __webpack_public_path__ + "static/img4-43c0c0fc600662035b1c4021572791a9.png";